import React from 'react';
import filter from 'mn-utils/filter';
import {
  openPopupWindow,
} from '../../../../../emitters/popup';
import WrapperWithLoading from '../../../../dumb/WrapperWithLoading/B';
import Popup from '../../../../dumb/Popup/B';
import {apiV2GetRefundDetails} from '../../../../../api/merchant/refunds';

import DisplayRefundCancellation from './DisplayRefundCancellation';
import DisplayRefundStatusChange from './DisplayRefundStatusChange';

module.exports = (id, update) => {
  console.log(update);
  openPopupWindow((setPopupState, popup, onMount) => {
    onMount(() => {
      setPopupState({
        loading: true,
        isRequested: true,
      });
      apiV2GetRefundDetails({id})
          .then((res) => {
            if (res.status !== 'requested') {
              update && update();
              setPopupState({
                isRequested: false,
              });
              return;
            }

            setPopupState({
              id: res.id,
              time: res.created_at || '',
              fiatAmount: res.fiat_amount || '',
              fiatCurrencyCode: res.fiat_code || '',
              email: res.email || '',
            });
          }).finally(() => {
            setPopupState({
              loading: false,
            });
          });
    });
    const {
      close,
    } = popup;
    return (stateOfPopup) => {
      const {isRequested, loading, ...props} = stateOfPopup;

      const title = loading
        ? 'Checking refund status'
        : isRequested
          ? 'Are you sure you want to cancel this refund?'
          : 'Error!';


      const Display = isRequested
        ? DisplayRefundCancellation
        : DisplayRefundStatusChange;

      return (
        <Popup caption={title}>
          <WrapperWithLoading
            loading={loading}
          >
            <Display {...props} setPopupState={setPopupState} update={update} close={close} />
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
